import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

// Spinner component
const Spinner = ({
  size = 40,
  color = 'primary',
  center = true,
  margin = 2,
  thickness = 3.6,
  ...props
}) => {
  // Проверяем, является ли цвет одним из предопределенных MUI или кастомным
  const isCustomColor = ![
    'primary',
    'secondary',
    'success',
    'error',
    'info',
    'warning',
  ].includes(color);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: center ? 'center' : 'flex-start',
        alignItems: 'center',
        my: margin,
      }}
    >
      {isCustomColor ? (
        <CircularProgress
          size={size}
          thickness={thickness}
          sx={{ color }}
          {...props}
        />
      ) : (
        <CircularProgress
          size={size}
          color={color}
          thickness={thickness}
          {...props}
        />
      )}
    </Box>
  );
};

Spinner.propTypes = {
  /**
   * The size of the spinner.
   */
  size: PropTypes.number,
  /**
   * The color of the spinner. Can be a theme color or any valid CSS color.
   */
  color: PropTypes.string,
  /**
   * If true, the spinner will be centered.
   */
  center: PropTypes.bool,
  /**
   * The vertical margin (in theme spacing units).
   */
  margin: PropTypes.number,
  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,
};

export default Spinner;
